import apiClient from "./axiosConfig";
import { AuthResponse } from "../../types/auth";

export const authenticateUser = async (initData: string): Promise<AuthResponse> => {
  const response = await apiClient.post<AuthResponse>(
    "api/auth/telegram",
    { initData }, // 👈 отправляем как объект
    {
      headers: {
        "Content-Type": "application/json", // 👈 корректный заголовок
      },
    }
  );
  return response.data;
};
